import ApiCore from "./common/api-core";

const url = "ExternalAuthApi";

const apiTasks = new ApiCore({
  getAll: false,
  getSingle: false,
  post: true,
  put: false,
  patch: false,
  delete: false,
  url: url,
});

export const externalAuthService = {
  getAuthUrl,
  exchangeCodeForToken,
  refreshToken,
};

// Get the OAuth provider authorization URL (Google, Outlook, etc.)
function getAuthUrl(provider) {
  return apiTasks.post("GetOAuthUrl", { provider })
    .then(response => {
      if (response.isAxiosError) {
        return Promise.reject(response);
      }
      return response;
    });
}

// Exchange authorization code (from OAuth callback) for access tokens
function exchangeCodeForToken(provider, code) {
  return apiTasks.post("ExchangeCodeForToken", { provider, code })
    .then(response => {
      if (response.isAxiosError) {
        return Promise.reject(response);
      }
      return response;
    });
}

// Refresh the access token with a refresh token
function refreshToken(refreshToken) {
  return apiTasks.post("RefreshToken", { refreshToken })
    .then(response => {
      if (response.isAxiosError) {
        return Promise.reject(response);
      }
      return response;
    });
}
